import script from "./BaseForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseForm.vue?vue&type=script&lang=ts&setup=true"

import "./BaseForm.vue?vue&type=style&index=0&id=0b17236c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b17236c"]])

export default __exports__